export const animation = {
  duration: {
    fast: '0.2s',
    normal: '0.3s',
    slow: '0.4s'
  },
  
  easing: {
    easeInOut: 'ease-in-out',
    ease: 'ease'
  }
} as const

export type Animation = typeof animation